<template lang="html">
  <div
    :class="[
      'none-panel flex flex-wrap items-center justify-center gap-4 px-4 py-10',
      props.ui.root?.class,
    ]"
  >
    <UiPicture
      src="None.svg"
      provider="ipx"
      variant="imageFull"
      v-bind="props.ui.image"
      :class="['overflow-h none-panel__image h-40 w-40', props.ui.image?.class]"
    />

    <div
      v-bind="props.ui.text"
      :class="['none-panel__text', props.ui.text?.class]"
    >
      <slot name="text">
        <p class="text-center text-xl font-bold">
          Пока ничего нет
        </p>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import UiPicture from '../Image/UiPicture.vue'

export type NonePanelUi = {
  root?: Record<any, any>
  image?: Record<any, any>
  text?: Record<any, any>
}

const props = withDefaults(
  defineProps<{
    ui?: NonePanelUi
  }>(),
  {
    ui: () => ({}),
  },
)

const slots = defineSlots<{
  text?(): void
}>()
</script>
